import React, { useState, useRef } from 'react';
import ReactQuill, { Quill } from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

function KdmEditor(props) {
  const [value, setValue] = useState(props?.text);
  const quillRef = useRef(null);
  
  return <ReactQuill ref={quillRef} className={'smallEditor '+props?.className} theme="snow" value={value} 
  //onChange={setValue} 
   onChange={(txt) => {
    console.clear();
    console.debug("jajajaja", txt)
      props?.onBlur({value: txt}, 'description')
      setValue(txt);
    }}
  >
    
    </ReactQuill>
    ;
}

export default KdmEditor;